module.exports = __webpack_public_path__ + "img/folder.48ff6189.png";